import { all } from 'redux-saga/effects';
import loginSagas from './login-sagas';
import userSagas from './user-sagas';
import dataSagas from './data-sagas';
import searchSagas from './search-sagas';

export default function* rootSaga() {
  yield all([loginSagas(), userSagas(), dataSagas(), searchSagas()]);
}
